import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
const { EFPic } = createEFPic('/media/mh200/h5/');

export default function MhJh5({}: any) {
    const { useLang, useEffect, useState } = useGlobal();
    const { t } = useLang('waveportableairconditioner');
    let controller;
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    const [isEnterA, setIsEnterA] = useState(false);
    const [isEnterB, setIsEnterB] = useState(false);

    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.mhJh5', //触发元素
            offset: layoutH / 2, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '50%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        sceneA1.on('enter', function () {
            setIsEnterA(true);
        });
        sceneA1.on('leave', function () {
            setIsEnterA(false);
        });

        controller.addScene(sceneA1);
    }, []);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.mhJh5', //触发元素
            offset: layoutH, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '150%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        sceneA1.on('enter', function () {
            setIsEnterB(true);
        });
        sceneA1.on('leave', function () {
            setIsEnterB(false);
        });

        controller.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.mhJh5} mhJh5`}>
            <div className="mhJh5-out">
                <div className="ef-scroll-ani-total-box">
                    <div className="ef-scroll-ani">
                        <div className="ef-scroll-ani-trigger">
                            <div className="ef-scroll-ani-inter">
                                <div className={`mhJh5-in ${isEnterA ? 'isEnterA' : ''} ${isEnterB ? 'isEnterB' : ''}`}>
                                    <div className="ms-center ms-title1">{t('mh200.mhI_ms1')}</div>
                                    <div className="ms-center ms-title2">{t('mh200.mhI_ms2')}</div>
                                    <div className="ms-center ms-title3">
                                        <div className="ms-title3-move ms-title3-move-1">{t('mh200.mhI_ms3')}</div>
                                        <div className="ms-title3-move ms-title3-move-2">{t('mh200.mhI_ms4')}</div>
                                        <div className="ms-title3-move ms-title3-move-3">{t('mh200.mhI_ms5')}</div>
                                    </div>
                                    <div className="img-box-out">
                                        <div className="img-box img-box1">
                                            <EFPic name={['product08_1.webp', 'product08_1.jpg']} className="fullImgs" alt={t('mh200.mhI_ms3')} />
                                        </div>
                                        <div className="img-box img-box2">
                                            <EFPic name={['product08_2.webp', 'product08_2.jpg']} className="fullImgs" alt={t('mh200.mhI_ms4')} />
                                        </div>
                                        <div className="img-box img-box3">
                                            <EFPic name={['product08_3.webp', 'product08_3.jpg']} className="fullImgs" alt={t('mh200.mhI_ms5')} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="ms-center ms-desc">{t('mh200.mhI_ms6')}</div>
        </div>
    );
}
